export default __webpack_public_path__ + "static/media/UBCStudentHealthBG.27514060.jpg";